import { ErrorIcon } from '@p2p/assets/svg';
import { Button, Typography } from '@p2p/components';
import { MainContainer, useTimer } from '@p2p/entities/payment';
import { PaymentTemplate } from '@p2p/entities/templates';
import { useGetMerchantOrderQuery } from '@p2p/services';
import classNames from 'classnames';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import styles from './ErrorPaymentPage.module.scss';

const COUNT_SECONDS = 5;

export const ErrorPaymentPage = () => {
  const { id } = useParams();
  const { data: order } = useGetMerchantOrderQuery(id ?? '');

  const handleFailed = useCallback(() => {
    window.location.replace(order?.merchant_failed_page || '/');
  }, [order?.merchant_failed_page]);
  const { second, locateWordSecond } = useTimer({ time: COUNT_SECONDS, onTimeout: handleFailed });

  return (
    <PaymentTemplate hideSteps>
      <MainContainer className={classNames(styles.transfer_dialog, styles.transfer_dialog_wide)}>
        <div className={classNames(styles.transfer_dialog__body, styles.centered)}>
          <div className={styles.transfer_dialog__icon_wr}>
            <ErrorIcon className={styles.transfer_dialog__icon} />
          </div>

          <Typography variant="h1" color="heading" className={styles.transfer_dialog__title}>
            К сожалению, нам не удалось найти подходящих реквизитов
          </Typography>
          <Typography variant="text-l-medium" className={styles.transfer_dialog__description}>
            Мы перенаправим Вас на сайт через {second} {locateWordSecond}
          </Typography>
        </div>
        <Button onClick={handleFailed}>Вернуться на сайт</Button>
      </MainContainer>
    </PaymentTemplate>
  );
};
